import { Typography, Link, Box } from "@mui/material";

export default function ChatFooter({ client, baseUrl, t, lang }) {
  return (
    <Box px={1} 
      sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",   // horizontal centering
            justifyContent: "center",
            textAlign: "center",    // text centering
            px: 1,
            py: 1
        }}
    >
      <Typography
        variant="caption"
        sx={{
          color: client.chatbot_system_color || "#000",
          lineHeight: 1.6,
        }}
      >
        {/* ENV LABELS */}
        {baseUrl.includes("dev-2") && (
          <Box component="span" sx={{ color: "orange", fontWeight: "bold" }}>
            DEV{" "}
          </Box>
        )}
        {baseUrl.includes("preprod") && (
          <Box component="span" sx={{ color: "purple", fontWeight: "bold" }}>
            PREPROD{" "}
          </Box>
        )}

        {/* CREATED BY */}
        {t("createdBy", lang)}{" "}
        <Link
          href="https://www.tcmconseils.com/"
          target="_blank"
          rel="noopener"
          underline="always"
          sx={{ fontSize: "0.65rem", fontWeight: 500 }}
        >
          TCMCONSEILS
        </Link>

        <br />

        {/* SECOND LINE */}
        <Box component="span" sx={{ fontSize: "0.5rem" }}>
          {t("prevention", lang)}{" "}
          <Link
            href="https://www.quebotia.com/#/privacy-policy"
            target="_blank"
            rel="noopener"
            underline="always"
            sx={{ fontSize: "0.5rem" }}
          >
            {t("privacy", lang)}
          </Link>{" "}
          {t("and", lang)}{" "}
          <Link
            href="https://www.quebotia.com/#/terms-of-service"
            target="_blank"
            rel="noopener"
            underline="always"
            sx={{ fontSize: "0.5rem" }}
          >
            {t("terms", lang)}
          </Link>
          .
        </Box>
      </Typography>
    </Box>
  );
}
